import { Map, List } from "immutable";
import { CASE_DETAILS_ACTIONS, STATE_STATUS } from "constants";
import { CaseDetailRecord, NachMandateStatusRecord } from "records";
import { CaseAssociateRecord } from "records/case-record";
import { CaseDetailRecordPipeline } from "utilities/data-pipelines";
// import uuid from "uuid/v4";

const INITIAL_STATE = new Map({});

const DEFAULT_CASE_STATE = new Map({
    status: STATE_STATUS.UNFETCHED,
    associatesStatus: STATE_STATUS.UNFETCHED,
    addressesStatus: STATE_STATUS.UNFETCHED,
    bankAccountsStatus: STATE_STATUS.UNFETCHED,
    cibilStatus: STATE_STATUS.UNFETCHED,
    caseAssociates: new Map({
        status: STATE_STATUS.UNFETCHED,
        data: new Map({}),
        deleteAssociateStatus : STATE_STATUS.UNFETCHED,
    }),
    caseBankAccounts: new Map({
        status: STATE_STATUS.UNFETCHED,
        data: new Map({})
    }),
    channelProductStats: new Map({
        status: STATE_STATUS.UNFETCHED,
        data: new Map({})
    }),

    data: new CaseDetailRecord(),
    remarksStatus : STATE_STATUS.UNFETCHED,
    nachMandate: Map({
        status: STATE_STATUS.UNFETHED,
        data : Map({})
    }),

    nachStatusResponse: Map({
        status: STATE_STATUS.UNFETHED,
        data : [],
        emi_dates: [],
        bank_account: {}
    }),

});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case CASE_DETAILS_ACTIONS.FETCH_CASE_DETAILS:
        return state.set(
            payload.caseId,
            DEFAULT_CASE_STATE.set("status", STATE_STATUS.FETCHING)
                .set("addressesStatus", STATE_STATUS.FETCHING)
                .set("associatesStatus", STATE_STATUS.FETCHING)
                .set("bankAccountsStatus", STATE_STATUS.FETCHING)
        );
    case CASE_DETAILS_ACTIONS.FETCHED_CASE_DETAILS:
        return state
            .setIn([payload.caseId, "status"], STATE_STATUS.FETCHED)
            .setIn(
                [payload.caseId, "addressesStatus"],
                STATE_STATUS.FETCHED
            )
            .setIn(
                [payload.caseId, "associatesStatus"],
                STATE_STATUS.FETCHED
            )
            .setIn(
                [payload.caseId, "bankAccountsStatus"],
                STATE_STATUS.FETCHED
            )
            .setIn(
                [payload.caseId, "cibilStatus"],
                STATE_STATUS.FETCHED
            )
            .setIn(
                [payload.caseId, "data"],
                CaseDetailRecordPipeline.run(payload.caseDetail)
            );
    case CASE_DETAILS_ACTIONS.FAILED_FETCH_CASE_DETAILS:
        return state.setIn(
            [payload.caseId, "status"],
            STATE_STATUS.FETCH_FAILED
        );
    case CASE_DETAILS_ACTIONS.UPDATE_CASE_DETAILS:
        return state.setIn(
            [payload.caseId, "status"],
            STATE_STATUS.UPDATING
        );
    case CASE_DETAILS_ACTIONS.UPDATED_CASE_DETAILS:
        return state
            .setIn([payload.caseId, "status"], STATE_STATUS.FETCHED)
            .setIn(
                [payload.caseId, "data"],
                CaseDetailRecordPipeline.run(payload.caseDetail)
            );
    case CASE_DETAILS_ACTIONS.FAILED_UPDATE_CASE_DETAILS:
        return state.setIn(
            [payload.caseId, "status"],
            STATE_STATUS.FETCH_FAILED
        );
    case CASE_DETAILS_ACTIONS.FETCH_CHANNEL_PRODUCT_STATS:
        return state.setIn(
            [payload.caseId, "channelProductStats", "status"],
            STATE_STATUS.FETCHING
        );
    case CASE_DETAILS_ACTIONS.FETCHED_CHANNEL_PRODUCT_STATS:
        return state
            .setIn([payload.caseId, "channelProductStats", "status"], STATE_STATUS.FETCHED)
            .setIn(
                [payload.caseId,"channelProductStats", "data"],
                new List(payload.channelProducts).toMap().mapEntries(([,v]) => ([v.id, v])).map(_ => {
                    const row = _;
                    if(_.value_type === 1) {
                        row.value = _.amount;
                    }
                    if(_.value_type === 2) {
                        row.value = _.percentage;
                    }
                    return row;
                })
            );
    case CASE_DETAILS_ACTIONS.FAILED_FETCH_CHANNEL_PRODUCT_STATS:
        return state.setIn(
            [payload.caseId, "channelProductStats", "status"],
            STATE_STATUS.FETCH_FAILED
        );
    case CASE_DETAILS_ACTIONS.UPDATE_CHANNEL_PRODUCT_STATS:
        return state.setIn(
            [payload.caseId, "channelProductStats", "status"],
            STATE_STATUS.UPDATING
        );
    case CASE_DETAILS_ACTIONS.UPDATED_CHANNEL_PRODUCT_STATS:
        return state
            .setIn([payload.caseId, "channelProductStats", "status"], STATE_STATUS.UPDATED)
            .setIn(
                [payload.caseId,"channelProductStats", "data"],
                new List(payload.channelProducts).toMap().mapEntries(([,v]) => ([v.id, v])).map(_ => {
                    const row = _;
                    if(_.value_type === 1) {
                        row.value = _.amount;
                    }
                    if(_.value_type === 2) {
                        row.value = _.percentage;
                    }
                    return row;
                })
            );
    case CASE_DETAILS_ACTIONS.FAILED_UPDATE_CHANNEL_PRODUCT_STATS:
        return state.setIn(
            [payload.caseId, "channelProductStats", "status"],
            STATE_STATUS.UPDATE_FAILED
        );

        
    case CASE_DETAILS_ACTIONS.UPDATE_CASE_REMARKS: 
        return state.setIn(
            [payload.caseId, "remarksStatus"], STATE_STATUS.FETCHING
        )
    

    case CASE_DETAILS_ACTIONS.UPDATED_CASE_REMARKS:
        return state.setIn(
            [payload.caseId, "data", "remarks"], payload.remarks
        ).setIn(
            [payload.caseId, "data", "internal_remarks"], payload.internalRemarks
        ).setIn([payload.caseId, "remarksStatus"], STATE_STATUS.FETCHED);

    case CASE_DETAILS_ACTIONS.FAILED_UPDATE_CASE_REMARKS:
        return state.setIn(
            [payload.caseId, "remarksStatus"],
            STATE_STATUS.FETCH_FAILED
        );

    case CASE_DETAILS_ACTIONS.FETCHED_CASE_REMARKS:
        return state.setIn(
            [payload.caseId, "data", "remarks"], payload.remarks
        ).setIn(
            [payload.caseId, "data", "internal_remarks"], payload.internalRemarks
        );
    case CASE_DETAILS_ACTIONS.UPDATED_COMPANY_LEDGERS:
        return state.setIn([payload.caseId, "uploadedLedgers"], payload.data);
    case CASE_DETAILS_ACTIONS.UPDATE_CASE_QUESTIONNAIRE:
        return state.setIn(
            [payload.caseId, "data", "questionnaire"],
            new Map(payload.questionnaire).sort((a, b) => {
                if (a.sno < b.sno) {
                    return -1;
                }
                if (a.sno > b.sno) {
                    return 1;
                }
                if (a.sno === b.sno) {
                    return 0;
                }
            })
        );
    case CASE_DETAILS_ACTIONS.UPDATED_CASE_QUESTIONNAIRE:
        return state
            .setIn([payload.caseId, "status"], STATE_STATUS.FETCHED)
            .setIn(
                [payload.caseId, "data", "questionnaire"],
                new Map(payload.data).sort((a, b) => {
                    if (a.sno < b.sno) {
                        return -1;
                    }
                    if (a.sno > b.sno) {
                        return 1;
                    }
                    if (a.sno === b.sno) {
                        return 0;
                    }
                })
            );
    case CASE_DETAILS_ACTIONS.FAILED_UPDATE_CASE_QUESTIONNAIRE:
        return state.setIn([payload.caseId, "status"], STATE_STATUS.FETCHED);
    case CASE_DETAILS_ACTIONS.FETCH_CASE_ASSOCIATES:
        return state.setIn(
            [payload.caseId, "caseAssociates", "status"],
            STATE_STATUS.FETCHING
        );
    case CASE_DETAILS_ACTIONS.FETCHED_CASE_ASSOCIATES:
        return state.setIn(
            [payload.caseId, "caseAssociates", "status"],
            STATE_STATUS.FETCHED
        ).setIn(
            [payload.caseId, "caseAssociates", "data"],
            new List(payload.data && payload.data.map(_ => new CaseAssociateRecord(_)))
        );
    case CASE_DETAILS_ACTIONS.FAILED_FETCH_CASE_ASSOCIATES:
        return state.setIn(
            [payload.caseId, "caseAssociates", "status"],
            STATE_STATUS.FETCH_FAILED
        );
    case CASE_DETAILS_ACTIONS.ADD_CASE_ASSOCIATES:
        return state.setIn(
            [payload.caseId, "caseAssociates", "status"],
            STATE_STATUS.UPDATING
        );
    case CASE_DETAILS_ACTIONS.ADDED_CASE_ASSOCIATES:
        return state.setIn(
            [payload.caseId, "caseAssociates", "status"],
            STATE_STATUS.UPDATED
        );
    case CASE_DETAILS_ACTIONS.FAILED_ADD_CASE_ASSOCIATES:
        return state.setIn(
            [payload.caseId, "caseAssociates", "status"],
            STATE_STATUS.UPDATE_FAILED
        );
    case CASE_DETAILS_ACTIONS.DELETE_CASE_ASSOCIATES:
        return state.setIn(
            [payload.caseId, "caseAssociates", "status"],
            STATE_STATUS.UPDATING
        );
    case CASE_DETAILS_ACTIONS.DELETED_CASE_ASSOCIATES:
        return state.setIn(
            [payload.caseId, "caseAssociates", "status"],
            STATE_STATUS.UPDATED
        ).setIn(
            [payload.caseId, "caseAssociates", "data"],
            payload.data
        ).setIn([payload.caseId, "caseAssociates", "deleteAssociateStatus"] , STATE_STATUS.FETCHED);
    case CASE_DETAILS_ACTIONS.FAILED_DELETE_CASE_ASSOCIATES:
        return state.setIn(
            [payload.caseId, "caseAssociates", "status"],
            STATE_STATUS.UPDATE_FAILED
        );
    case CASE_DETAILS_ACTIONS.UPDATE_DELETE_ASSOCIATE_STATUS:
        return state.setIn(
            [payload.caseId, "caseAssociates", "deleteAssociateStatus"],
            STATE_STATUS.UNFETCHED
        );
    // case CIBIL_ACTIONS.CIBIL_REQUESTED: {
    //     let updatedAssociates = state.getIn([payload.caseId, "caseAssociates", "data"]);
    //     if(updatedAssociates.size || updatedAssociates.length) {
    //         updatedAssociates = updatedAssociates.withMutations(list => 
    //             list.map(_ => {
    //                 if(_.company_associate && _.company_associate.id == payload.associateId) {
    //                     _.set("is_cibil_requested", true);
    //                     console.log(_, payload);
    //                 }
    //                 return _;
    //             })
    //         );
    //     }
    //     return state.setIn([payload.caseId, "caseAssociates", "data"], updatedAssociates);
    // }
    case CASE_DETAILS_ACTIONS.FETCH_CASE_BANK_ACCOUNTS:
        return state.setIn(
            [payload.caseId, "caseBankAccounts", "status"],
            STATE_STATUS.FETCHING
        );
    case CASE_DETAILS_ACTIONS.FETCHED_CASE_BANK_ACCOUNTS:
        return state.setIn(
            [payload.caseId, "caseBankAccounts", "status"],
            STATE_STATUS.FETCHED
        ).setIn(
            [payload.caseId, "caseBankAccounts", "data"],
            payload.data
        );
    case CASE_DETAILS_ACTIONS.FAILED_FETCH_CASE_BANK_ACCOUNTS:
        return state.setIn(
            [payload.caseId, "caseBankAccounts", "status"],
            STATE_STATUS.FETCH_FAILED
        );
    case CASE_DETAILS_ACTIONS.ADD_CASE_BANK_ACCOUNTS:
        return state.setIn(
            [payload.caseId, "caseBankAccounts", "status"],
            STATE_STATUS.UPDATING
        );
    case CASE_DETAILS_ACTIONS.ADDED_CASE_BANK_ACCOUNTS:
        return state.setIn(
            [payload.caseId, "caseBankAccounts", "status"],
            STATE_STATUS.UPDATED
        );
    case CASE_DETAILS_ACTIONS.FAILED_ADD_CASE_BANK_ACCOUNTS:
        return state.setIn(
            [payload.caseId, "caseBankAccounts", "status"],
            STATE_STATUS.UPDATE_FAILED
        );
    case CASE_DETAILS_ACTIONS.DELETE_CASE_BANK_ACCOUNTS:
        return state.setIn(
            [payload.caseId, "caseBankAccounts", "status"],
            STATE_STATUS.UPDATING
        );
    case CASE_DETAILS_ACTIONS.DELETED_CASE_BANK_ACCOUNTS:
        return state.setIn(
            [payload.caseId, "caseBankAccounts", "status"],
            STATE_STATUS.UPDATED
        ).setIn(
            [payload.caseId, "caseBankAccounts", "data"],
            payload.data
        );
    case CASE_DETAILS_ACTIONS.FAILED_DELETE_CASE_BANK_ACCOUNTS:
        return state.setIn(
            [payload.caseId, "caseBankAccounts", "status"],
            STATE_STATUS.UPDATE_FAILED
        );
    case CASE_DETAILS_ACTIONS.FETCH_CASE_CHECKLIST:
        return state.setIn(
            [payload.caseId, "checklist", "status"],
            STATE_STATUS.FETCHING
        )
            .setIn(
                [payload.caseId, "checklist", "loading"],
                true
            );
    case CASE_DETAILS_ACTIONS.FETCHED_CASE_CHECKLIST:
        return state.setIn(
            [payload.caseId, "checklist", "status"],
            STATE_STATUS.FETCHED
        )
            .setIn(
                [payload.caseId, "checklist", "data"],
                new Map(payload.data)
            )
            .setIn(
                [payload.caseId, "checklist", "loading"],
                false
            );
        
    case CASE_DETAILS_ACTIONS.FAILED_FETCH_CASE_CHECKLIST:
        return state.setIn(
            [payload.caseId, "checklist", "status"],
            STATE_STATUS.FETCH_FAILED
        )
            .setIn(
                [payload.caseId, "checklist", "data"],
                new Map(payload.data)
            )
            .setIn(
                [payload.caseId, "checklist", "loading"],
                false
            )
            .setIn(
                [payload.caseId, "checklist", "error"],
                payload.error
            );
        case CASE_DETAILS_ACTIONS.FETCH_GSTIN_SEARCH:
            return state
                .setIn([payload.caseId, "gstinSearchListStatus"], payload.status);

        case CASE_DETAILS_ACTIONS.FETCH_CASE_NACH_MANDATE_DETAILS:
            return state.setIn(
                [payload.caseId, "nachMandate", "status"],
                STATE_STATUS.FETCHING
            );
        case CASE_DETAILS_ACTIONS.FETCHED_CASE_NACH_MANDATE_DETAILS:
            return state
                .setIn([payload.caseId,"nachMandate", "data" ],Map(payload.data))
                .setIn([payload.caseId,"nachMandate", "status"], STATE_STATUS.FETCHED);
    
        case CASE_DETAILS_ACTIONS.FETCH_FAILED_CASE_NACH_MANDATE_DETAILS:
            return state.setIn(
                [payload.caseId, "nachMandate",  "status"],
                STATE_STATUS.FETCH_FAILED
            );
        case CASE_DETAILS_ACTIONS.FETCH_CASE_ENACH_MANDATE_STATUS:
            return state.setIn(
                [payload.caseId, "nachStatusResponse", "status"],
                STATE_STATUS.FETCHING
            );
        case CASE_DETAILS_ACTIONS.FETCHED_CASE_ENACH_MANDATE_STATUS:
            // const bank_details = payload.data && payload.data.results.length && Map(payload.data.results[0].bank_details)
            // payload.data.results
            // const dataWithImmutableBankDetails = {
            //     ...payload.data.results,
            //     bank_details: Map(payload.data.bank_details),
            // };
            const nachMandateList = payload.data.results.map(
                item => new NachMandateStatusRecord(item)
            );
            return state
                .setIn([payload.caseId, "nachStatusResponse", "emi_dates"], payload.data.emi_dates.flat())
                .setIn([payload.caseId, "nachStatusResponse", "bank_account"], payload.data.bank_account)
                .setIn([payload.caseId, "nachStatusResponse", "data"], nachMandateList)
                .setIn([payload.caseId, "nachStatusResponse", "status"], STATE_STATUS.FETCHED);

        case CASE_DETAILS_ACTIONS.FETCH_FAILED_CASE_ENACH_MANDATE_STATUS:
            return state.setIn(
                [payload.caseId, "nachStatusResponse", "status"],
                STATE_STATUS.FETCH_FAILED
            );
    case CASE_DETAILS_ACTIONS.FETCH_CASE_DETAIL_FIELDS:
        return state.setIn([payload.caseId, "caseDetailFields", "status"], STATE_STATUS.FETCHING);
    case CASE_DETAILS_ACTIONS.FETCHED_CASE_DETAIL_FIELDS:
        return state
            .setIn([payload.caseId, "caseDetailFields", "status"], STATE_STATUS.FETCHED)
            .setIn([payload.caseId, "caseDetailFields", "data"], new Map(payload.data));
    case CASE_DETAILS_ACTIONS.FAILED_FETCH_CASE_DETAIL_FIELDS:
        return state.setIn([payload.caseId, "caseDetailFields", "status"], STATE_STATUS.FETCH_FAILED);
    case CASE_DETAILS_ACTIONS.UPDATE_CASE_DETAIL_FIELDS:
        return state.setIn([payload.caseId, "caseDetailFields", "status"], STATE_STATUS.UPDATING);
    case CASE_DETAILS_ACTIONS.UPDATED_CASE_DETAIL_FIELDS:
        return state
            .setIn([payload.caseId, "caseDetailFields", "status"], STATE_STATUS.UPDATED)
            .setIn([payload.caseId, "caseDetailFields", "data"], new Map(payload.data));
    case CASE_DETAILS_ACTIONS.FAILED_UPDATE_CASE_DETAIL_FIELDS:
        return state.setIn([payload.caseId, "caseDetailFields", "status"], STATE_STATUS.UPDATE_FAILED);

    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};